// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"22":"component---src-pages-reservations-tsx","650":"component---src-pages-shotgum-tsx","691":"component---src-pages-index-tsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"22":"398dfa3e68d7d98060ab","650":"ec0ed10b6b156a01c837","691":"3cc663ad4f9f02f0df7e","883":"3ebb1cd02ebead60e405"}[chunkId] + ".js";
};